import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col } from '../../components/Col';
import { CustomButton } from '../../components/CustomButton';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import styles from './PlanoTrabalho.scss';
import PlanoTrabalhoItem from './PlanoTrabalhoItem';
import { AddIcon } from 'assets/icons/AddIcon';

const rootClassName = styles.rootClassName;

class PlanoTrabalho extends Component {
  allowEditButton() {
    return this.props.auth.userPermissions.contratos.entePrivado.edit
      ? true
      : false;
  }

  render() {
    return (
      <div
        className={getMergedClassNames([
          rootClassName,
          typeof this.props.className === 'string' ? this.props.className : '',
        ])}
      >
        <Table className={rootClassName + '-table'}>
          <TableHead>
            <TableRow>
              {this.props.contratosEntePrivado.contratoEditing.planoTrabalho
                .length > 0 ? (
                <>
                  {this.allowEditButton() ? (
                    <TableCell
                      className={
                        rootClassName + '-cell ' + rootClassName + '-edit-cell'
                      }
                    ></TableCell>
                  ) : null}
                  <TableCell className={rootClassName + '-cell'}>
                    {this.props.languageValues.linhaOrcamentariaLabel}
                  </TableCell>
                  <TableCell className={rootClassName + '-cell'}>
                    {this.props.languageValues.oqueLabel}
                  </TableCell>
                  <TableCell className={rootClassName + '-cell'}>
                    {this.props.languageValues.quandoLabel}
                  </TableCell>
                  <TableCell
                    className={
                      rootClassName + '-cell ' + rootClassName + '-toggle-cell'
                    }
                  ></TableCell>
                </>
              ) : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.contratosEntePrivado.contratoEditing.planoTrabalho.map(
              (planoTrabalho, index) => {
                return (
                  <PlanoTrabalhoItem
                    planoTrabalho={planoTrabalho}
                    key={index}
                    fieldDisabled={this.props.fieldDisabled}
                    changePlanoTrabalho={this.props.changePlanoTrabalho}
                  />
                );
              }
            )}
          </TableBody>
        </Table>
        {this.props.contratosEntePrivado.contratoEditing.planoTrabalho
          .length === 0 ? (
          <Col
            cols={[12, 12, 12, 12, 12]}
            className={rootClassName + '-hidden-cadastro-buttom'}
          >
            <CustomButton
              className={rootClassName + `-modal-cadastro-buttom`}
              label={this.props.languageValues.labelPlanoDeTrabalho}
              theme='pufvYellow'
              onClick={this.props.addPlanoTrabalho}
              disabled={this.props.fieldDisabled()}
              rightIcon={<AddIcon />}
            />
          </Col>
        ) : null}
      </div>
    );
  }
}

PlanoTrabalho.propTypes = {
  className: PropTypes.string,
  changePlanoTrabalho: PropTypes.func.isRequired,
  fieldDisabled: PropTypes.func.isRequired,
  addPlanoTrabalho: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  languageValues: state.languages.languageValues,
  contratosEntePrivado: state.contratosEntePrivado,
});

export default connect(mapStateToProps, null)(PlanoTrabalho);
